import { Mode } from '../types'

/* Функция для получения префикса города из хоста
  https://ufa.farfor.ru/ -> ufa
  https://site-0000.ufa.frfrstaging.ru/ -> ufa
*/
export const getCityFromDomain = (host: string, mode: string) => {
  const splitHost = host.split('.')

  // Для feature ссылок типа https://site-0000.ufa.frfrstaging.ru/
  if (mode === Mode.BRANCH) {
    return splitHost[1]
  }

  return splitHost[0]
}
